'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'tree-city';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e587';
var svgPathData = 'M336 32c-8.8 0-16 7.2-16 16l0 448c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-448c0-26.5 21.5-48 48-48L464 0c26.5 0 48 21.5 48 48l0 144 32 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 16 0c26.5 0 48 21.5 48 48l0 256c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-256c0-8.8-7.2-16-16-16l-32 0-64 0c-8.8 0-16-7.2-16-16l0-160c0-8.8-7.2-16-16-16L336 32zm48 32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm0 32l0 32 32 0 0-32-32 0zm96 192c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32zm64 0l-32 0 0 32 32 0 0-32zm-32 96l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm0 32l0 32 32 0 0-32-32 0zM352 224c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32zm64 0l-32 0 0 32 32 0 0-32zm-32 96l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm0 32l0 32 32 0 0-32-32 0zM128 224c8.8 0 16 7.2 16 16l0 48 32 0c26.5 0 48-21.5 48-48c0-16-7.8-30.2-19.9-38.9l-8-5.8c-4.9-3.5-7.4-9.5-6.4-15.5l.4-2.6c1.1-6.7 1.9-11.9 1.9-17.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.3 .8 10.5 1.9 17.2l.4 2.6c.9 6-1.5 11.9-6.4 15.5l-8 5.8C39.8 209.8 32 224 32 240c0 26.5 21.5 48 48 48l32 0 0-48c0-8.8 7.2-16 16-16zm-16 96l-32 0c-44.2 0-80-35.8-80-80c0-26.7 13.1-50.3 33.2-64.9c0 0 0 0 0 0c-.7-4.7-1.2-9.9-1.2-15.1c0-53 43-96 96-96s96 43 96 96c0 5.2-.5 10.4-1.2 15.1c0 0 0 0 0 0C242.9 189.7 256 213.3 256 240c0 44.2-35.8 80-80 80l-32 0 0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTreeCity = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;